import { localizeApiError } from '../../i18n/runtime';

function normalizeApiBaseUrl(raw) {
  const value = (raw || '').trim().replace(/\/+$/, '').replace(/\/api$/i, '');
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  if (/^\/\//.test(value)) return `https:${value}`;
  if (/^(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value)) return `http://${value}`;
  if (/^[a-z0-9.-]+\.[a-z]{2,}(:\d+)?(\/.*)?$/i.test(value)) return `https://${value}`;
  return value;
}

const RAW_API_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_URL = normalizeApiBaseUrl(RAW_API_URL);

export const apiConfig = {
  rawBackendUrl: RAW_API_URL,
  backendUrl: API_URL,
  usesSameOrigin: !API_URL,
  hasProtocol: !RAW_API_URL || /^https?:\/\//i.test(RAW_API_URL.trim()),
};

export function formatApiError(detail) {
  if (detail == null) return localizeApiError('');
  if (typeof detail === 'string') return localizeApiError(detail);
  if (Array.isArray(detail)) {
    const message = detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
    return localizeApiError(message);
  }
  if (detail && typeof detail.message === 'string') return localizeApiError(detail.message);
  if (detail && typeof detail.msg === 'string') return localizeApiError(detail.msg);
  return localizeApiError(String(detail));
}

export async function apiRequest(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;

  const config = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  let response;
  try {
    response = await fetch(url, config);
  } catch (err) {
    const hint = API_URL
      ? `Cannot reach backend at ${API_URL}. Check REACT_APP_BACKEND_URL and CORS.`
      : 'Backend URL is not configured. Set REACT_APP_BACKEND_URL for Railway.';
    const error = new Error(localizeApiError(`${hint} ${err.message || ''}`.trim()));
    error.cause = err;
    throw error;
  }

  if (response.status === 401 && !endpoint.includes('/auth/')) {
    window.location.href = '/login';
    throw new Error(localizeApiError('Session expired'));
  }

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(formatApiError(data.detail) || localizeApiError('Request failed'));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
